import { request } from '@/shared/api/request'

export const getContract = (externalId) => {
	return request({ url: `colcontract/get/${externalId}`, method: 'GET' })
}
